import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomAddressDropdown } from "@faire/retailer-visitor-shared/components/GoogleMapsComponent/CustomAddressDropdown";
import { useAutoComplete } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/useAutoComplete";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Input } from "@faire/web--source/slate/Input";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { IFindBusinessAddressRequest } from "@faire/web-api--source/indigofair/data/IFindBusinessAddressRequest";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { useEffect, useRef, useState } from "react";
import * as React from "react";
import styled from "styled-components";
export var AutoCompleteStoreName = function(param) {
    var formValues = param.formValues, setFieldValue = param.setFieldValue, setFormValues = param.setFormValues, error = param.error;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useAutoComplete = useAutoComplete(formValues.storeName, formValues.country), isDropdownOpen = _useAutoComplete.isDropdownOpen, setIsDropdownOpen = _useAutoComplete.setIsDropdownOpen, autoCompleteResults = _useAutoComplete.autoCompleteResults, areBusinessesLoading = _useAutoComplete.areBusinessesLoading, getBusinessAddress = _useAutoComplete.getBusinessAddress;
    var _useState = _sliced_to_array(useState(false), 2), resetAutofilledAddress = _useState[0], setResetAutofilledAddress = _useState[1];
    useEffect(function() {
        if (resetAutofilledAddress) {
            clearAddressFields(setFieldValue, setFormValues, formValues);
            // reset store name:
            setFieldValue("storeName", "");
            setFormValues(_object_spread_props(_object_spread({}, formValues), {
                storeName: ""
            }));
            setResetAutofilledAddress(false);
        }
    }, [
        resetAutofilledAddress,
        setFieldValue,
        setFormValues,
        formValues
    ]);
    var initialRender = useRef(true);
    useEffect(function() {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            setResetAutofilledAddress(true);
        }
    }, [
        formValues.country
    ]);
    var selectBusiness = function(option) {
        var _option_name;
        var storeName = (_option_name = option.name) !== null && _option_name !== void 0 ? _option_name : "";
        var matchedBusiness = IMatchedBusiness.build(_object_spread_props(_object_spread({}, option), {
            type: IMatchedBusiness.Type.GOOGLE_PLACES
        }));
        // now that user selected a business, we need to get the address,
        // First clear the address fields:
        clearAddressFields(setFieldValue, setFormValues, formValues);
        // and get the address:
        getBusinessAddress([
            IFindBusinessAddressRequest.build({
                business: matchedBusiness
            })
        ], {
            onSuccess: function(response) {
                if (response.address) {
                    var _response_address = response.address, _response_address_address1 = _response_address.address1, address1 = _response_address_address1 === void 0 ? "" : _response_address_address1, _response_address_address2 = _response_address.address2, address2 = _response_address_address2 === void 0 ? "" : _response_address_address2, _response_address_city = _response_address.city, city = _response_address_city === void 0 ? "" : _response_address_city, _response_address_state = _response_address.state, state = _response_address_state === void 0 ? "" : _response_address_state, tmp = _response_address.postal_code, zipcode = tmp === void 0 ? "" : tmp;
                    setFieldValue("address1", address1);
                    setFieldValue("address2", address2);
                    setFieldValue("city", city);
                    setFieldValue("state", state);
                    setFieldValue("zipcode", zipcode);
                    setFormValues(_object_spread_props(_object_spread({}, formValues), {
                        address1: address1,
                        address2: address2,
                        city: city,
                        state: state,
                        zipcode: zipcode
                    }));
                }
            }
        });
        setFieldValue("storeName", storeName);
        setFieldValue("matchedBusiness", matchedBusiness);
        setFormValues(_object_spread_props(_object_spread({}, formValues), {
            storeName: storeName,
            matchedBusiness: matchedBusiness
        }));
        setIsDropdownOpen(false);
    };
    var handleInputChange = function(e) {
        var matchedBusiness = IMatchedBusiness.build({
            type: IMatchedBusiness.Type.MANUAL,
            name: e.target.value
        });
        setFieldValue("storeName", e.target.value);
        setFieldValue("matchedBusiness", matchedBusiness);
        setFormValues(_object_spread_props(_object_spread({}, formValues), {
            matchedBusiness: matchedBusiness,
            storeName: e.target.value
        }));
        if (e.target.value.length > 0) {
            setIsDropdownOpen(true);
        } else {
            setIsDropdownOpen(false);
        }
    };
    return /*#__PURE__*/ _jsxs(CustomAddressDropdown, {
        open: isDropdownOpen,
        onOpen: function() {
            return setIsDropdownOpen(true);
        },
        onClose: function() {
            return setIsDropdownOpen(false);
        },
        options: autoCompleteResults,
        onSelect: selectBusiness,
        showCannotFindOption: true,
        onCannotFindClick: function() {
            clearAddressFields(setFieldValue, setFormValues, formValues);
            setIsDropdownOpen(false);
        },
        children: [
            /*#__PURE__*/ _jsx(Input, {
                type: "text",
                onChange: handleInputChange,
                label: strictLocalize({
                    id: "YzVhKb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Store Name"
                        }
                    ]
                }),
                value: formValues.storeName,
                error: error
            }),
            areBusinessesLoading ? /*#__PURE__*/ _jsx(StyledLoadingSpinner, {
                size: "small"
            }) : null
        ]
    });
};
var clearAddressFields = function(setFieldValue, setFormValues, formValues) {
    setFieldValue("address1", "");
    setFieldValue("address2", "");
    setFieldValue("city", "");
    setFieldValue("state", "");
    setFieldValue("zipcode", "");
    setFieldValue("phoneNumber", "");
    setFormValues(_object_spread_props(_object_spread({}, formValues), {
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipcode: "",
        phoneNumber: ""
    }));
};
var StyledLoadingSpinner = styled(LoadingSpinner).withConfig({
    componentId: "sc-faf02fc-0"
})([
    "position:absolute;top:32px;right:12px;"
]);
